import { middlewareController } from '../middlewareController'

const BASE_URL = process.env.REACT_APP_TASK_MANAGEMENT_BACKEND_ENDPOINT

export const taskManagementApi = middlewareController.create.axiosInstance({
  baseURL: BASE_URL
})

export * from './requests'
export * from './taskManagementApi.types'
